package data.search_data

import models.SearchData

// Search suggestions (78)
val ColosseumSearchSuggestions = listOf(
    "skyphos",
    "marble",
    "wall",
    "mosaic",
    "man",
    "ornament",
    "copper",
    "sarcophagus",
    "miscellaneous",
    "pentelic",
    "grotesque",
    "handle",
    "silver",
    "ring",
    "terracotta",
    "stone",
    "sculpture",
    "phallic",
    "urn",
    "panel",
    "cinerary",
    "vase",
    "beaker",
    "oil",
    "champlev",
    "ivory",
    "fresco",
    "funerary",
    "glass",
    "cup",
    "torso",
    "fragment",
    "lid",
    "decoration",
    "statuette",
    "amulet",
    "bronzes",
    "woman",
    "drinking",
    "relief",
    "bronze",
    "emperor",
    "villa",
    "bottle",
    "brooch",
    "fragmentary",
    "shaped",
    "ribbed",
    "paintings",
    "gold",
    "jar",
    "inscription",
    "pendant",
    "lamp",
    "spoon",
    "bone",
    "head",
    "enamel",
    "stucco",
    "painting",
    "flask",
    "bust",
    "statue",
    "imperial",
    "jug",
    "terracottas",
    "bowl",
    "enamels",
    "vases",
    "portrait"
)

// Machu Picchu (366)
val ColosseumSearchData = listOf(
    SearchData(
        149,
        251450,
        "Marble left hand holding a small box",
        "hand|marble|stone sculpture",
        "gr/mobile-large/DP231316.jpg",
        1.33
    ),
    SearchData(
        125,
        250559,
        "Bronze bust of a young satyr",
        "bust of a satyr, chariot attachment|bronze, silver, copper|bronzes",
        "gr/mobile-large/DP20474.jpg",
        1.00
    ),
    SearchData(
        349,
        249692,
        "Glass pendant in the form of a dolphin",
        "pendant in the form of a dolphin|glass|glass",
        "gr/mobile-large/DP121034.jpg",
        0.75
    ),
    SearchData(
        49,
        257866,
        "Marble cinerary urn in the form of a tree stump with leaves and grapes",
        "urn|marble|stone sculpture",
        "gr/mobile-large/DP-24425-001.jpg",
        0.75
    ),
    SearchData(
        40,
        245846,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112919.jpg",
        1.00
    ),
    SearchData(
        34,
        245285,
        "Glass bowl",
        "bowl, patella|glass|glass",
        "gr/mobile-large/DP105510.jpg",
        1.00
    ),
    SearchData(
        25,
        245364,
        "Glass beaker",
        "beaker|glass|glass",
        "gr/mobile-large/DP120991.jpg",
        1.00
    ),
    SearchData(
        100,
        246907,
        "Bronze batillum (incense shovel)",
        "shovel|bronze|bronzes",
        "gr/mobile-large/DP20384.jpg",
        1.09
    ),
    SearchData(
        100,
        250790,
        "Fragmentary bronze statuette of boy wearing a mantle",
        "statuette of a boy, upper part|bronze|bronzes",
        "gr/mobile-large/sf1919257.jpg",
        0.99
    ),
    SearchData(
        200,
        250096,
        "Three-handled jug with relief medallions",
        "jug|terracotta|vases",
        "gr/mobile-large/DP107074.jpg",
        1.00
    ),
    SearchData(
        49,
        257878,
        "A pair of glass drinking cups",
        "cups, pair|glass|glass",
        "gr/mobile-large/DP275294.jpg",
        1.33
    ),
    SearchData(
        199,
        250092,
        "Terracotta flask",
        "vase in the form of a pomegranate|terracotta|vases",
        "gr/mobile-large/DP117521.jpg",
        1.00
    ),
    SearchData(
        60,
        241579,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-19673-006.jpg",
        0.83
    ),
    SearchData(
        149,
        250258,
        "Terracotta flask",
        "vase|terracotta, glass|vases",
        "gr/mobile-large/DP107317.jpg",
        1.00
    ),
    SearchData(
        300,
        466583,
        "Sarcophagus Lid with Last Judgement",
        "sarcophagus lid|marble|sculpture-stone",
        "md/mobile-large/DT271481.jpg",
        5.41
    ),
    SearchData(
        124,
        257876,
        "Glass serving dish",
        "tray, cast|glass, greenish colorless|glass",
        "gr/mobile-large/DP286319.jpg",
        1.50
    ),
    SearchData(
        25,
        245648,
        "Glass mosaic bottle",
        "perfume bottle, mosaic|glass|glass",
        "gr/mobile-large/DP120995.jpg",
        1.00
    ),
    SearchData(
        25,
        257829,
        "Glass gold-band mosaic lid fragment",
        "lid fragment, gold-band mosaic|glass|glass",
        "gr/mobile-large/DP145727.jpg",
        1.33
    ),
    SearchData(
        -5,
        250946,
        "Wall painting: Polyphemus and Galatea in a landscape, from the imperial villa at Boscotrecase",
        "wall painting: polyphemus and galatea in a landscape|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP138763.jpg",
        0.67
    ),
    SearchData(
        149,
        250100,
        "Terracotta beaker with barbotine decoration",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP107680.jpg",
        1.00
    ),
    SearchData(
        199,
        250245,
        "Terracotta barrel-shaped jar",
        "jar, barrel-shaped|terracotta|vases",
        "gr/mobile-large/DP107354.jpg",
        1.00
    ),
    SearchData(
        200,
        473287,
        "Disk Brooch",
        "brooch|copper alloy, millefiori enamel|enamels-champlevé",
        "md/mobile-large/TR46922000OBV.jpg",
        0.88
    ),
    SearchData(
        12,
        257842,
        "Glass network mosaic bowl fragment",
        "fragment, mosaic network bowl|glass|glass",
        "gr/mobile-large/DP145738.jpg",
        0.75
    ),
    SearchData(
        25,
        249470,
        "Glass jug",
        "ennion jug|glass|glass",
        "gr/mobile-large/DP121998.jpg",
        0.75
    ),
    SearchData(
        100,
        256657,
        "Bronze statuette of a ram",
        "statuette of a ram|bronze|bronzes",
        "gr/mobile-large/DP2058.jpg",
        1.00
    ),
    SearchData(
        39,
        248851,
        "Marble portrait bust of the emperor Gaius, known as Caligula",
        "portrait bust of the emperor caligula|marble|stone sculpture",
        "gr/mobile-large/DP337262.jpg",
        0.75
    ),
    SearchData(
        -15,
        250064,
        "Terracotta cup",
        "cup|terracotta|vases",
        "gr/mobile-large/DP1293.jpg",
        1.00
    ),
    SearchData(
        100,
        249232,
        "Couch and footstool with bone carvings and glass inlays",
        "couch and footstool with bone carvings and glass inlay|wood, bone, glass|miscellaneous-bone, ivory",
        "gr/mobile-large/DP138722.jpg",
        1.63
    ),
    SearchData(
        100,
        246914,
        "Bronze simpulum (ladle)",
        "ladle|bronze|bronzes",
        "gr/mobile-large/DP20381.jpg",
        0.99
    ),
    SearchData(
        199,
        251506,
        "Bone hairpin with bust of a woman",
        "pin|bone|miscellaneous-bone, ivory",
        "gr/mobile-large/DP121062.jpg",
        0.75
    ),
    SearchData(
        50,
        246732,
        "Terracotta jug with barbotine decoration",
        "jug|terracotta|vases",
        "gr/mobile-large/DP109351.jpg",
        1.00
    ),
    SearchData(
        175,
        256570,
        "Bronze plaque of Mithras slaying the bull",
        "plaque of mithras killing the bull|bronze|bronzes",
        "gr/mobile-large/DP119236.jpg",
        0.84
    ),
    SearchData(
        50,
        257884,
        "Marble two-sided relief",
        "relief with masks|marble|stone sculpture",
        "gr/mobile-large/DP285251.jpg",
        1.33
    ),
    SearchData(
        -15,
        245787,
        "Glass garland bowl",
        "bowl|glass|glass",
        "gr/mobile-large/DP122006.jpg",
        0.74
    ),
    SearchData(
        20,
        257641,
        "Marble statue of a member of the imperial family",
        "statue of a young man, half-draped|marble|stone sculpture",
        "gr/mobile-large/DP-1353-002.jpg",
        0.75
    ),
    SearchData(
        150,
        255251,
        "Bronze statuette of a mouse",
        "statuette of a mouse from a lamp|bronze|bronzes",
        "gr/mobile-large/DP20805.jpg",
        1.01
    ),
    SearchData(
        50,
        250112,
        "Terracotta jug",
        "vase|terracotta|vases",
        "gr/mobile-large/DP107684.jpg",
        1.00
    ),
    SearchData(
        149,
        250098,
        "Terracotta jar with barbotine decoration",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP1282.jpg",
        1.00
    ),
    SearchData(137, 245170, "Glass jug", "jug|glass|glass", "gr/mobile-large/DP121441.jpg", 1.00),
    SearchData(
        25,
        241632,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-19673-001.jpg",
        1.21
    ),
    SearchData(
        67,
        250497,
        "Terracotta mortarium fragment",
        "mortarium fragment|terracotta|vases",
        "gr/mobile-large/DP231269.jpg",
        0.75
    ),
    SearchData(
        199,
        466288,
        "Brooch in the form of a Stag",
        "brooch|copper alloy, champleve enamel|metalwork-copper alloy",
        "md/mobile-large/sf1996-212s1.jpg",
        1.20
    ),
    SearchData(
        -50,
        250915,
        "Silver skyphos (drinking cup)",
        "skyphos|silver|gold and silver",
        "gr/mobile-large/GR874.jpg",
        1.08
    ),
    SearchData(
        100,
        246906,
        "Bronze batillum (incense shovel)",
        "shovel|bronze|bronzes",
        "gr/mobile-large/DP20376.jpg",
        2.03
    ),
    SearchData(
        199,
        249033,
        "Ivory needle",
        "needle|ivory|miscellaneous-bone, ivory",
        "gr/mobile-large/DP121009.jpg",
        0.75
    ),
    SearchData(
        50,
        251447,
        "Marble calyx-krater with reliefs of maidens and dancing maenads",
        "calyx-krater|marble, pentelic|stone sculpture",
        "gr/mobile-large/DT4541.jpg",
        0.80
    ),
    SearchData(
        149,
        250646,
        "Marble column with base and capital",
        "column|marble|stone sculpture",
        "gr/mobile-large/DP-14287-095.jpg",
        0.34
    ),
    SearchData(
        299,
        248959,
        "Glass strigil (scraper)",
        "strigil|glass|glass",
        "gr/mobile-large/DP107016.jpg",
        1.00
    ),
    SearchData(
        -50,
        250919,
        "Silver cochlear (spoon)",
        "spoon, cochlear|silver|gold and silver",
        "gr/mobile-large/DT277656.jpg",
        0.80
    ),
    SearchData(
        349,
        245716,
        "Glass beaker or lamp",
        "beaker or lamp|glass|glass",
        "gr/mobile-large/DP117585.jpg",
        1.00
    ),
    SearchData(
        100,
        250563,
        "Bronze statuette of an actor",
        "statuette of an actor|bronze|bronzes",
        "gr/mobile-large/DP20478.jpg",
        0.86
    ),
    SearchData(
        -100,
        254781,
        "Terracotta wine amphora",
        "amphora, pointed|terracotta|vases",
        "gr/mobile-large/DP121458.jpg",
        0.55
    ),
    SearchData(
        100,
        254968,
        "Gold funerary wreath",
        "wreath, funerary|gold|gold and silver",
        "gr/mobile-large/SF5759.jpg",
        1.33
    ),
    SearchData(
        50,
        245667,
        "Glass ribbed bowl",
        "bowl, rippenschale|glass|glass",
        "gr/mobile-large/DP120996.jpg",
        1.00
    ),
    SearchData(
        25,
        257855,
        "Marble funerary altar",
        "funerary altar of anthus|marble|stone sculpture",
        "gr/mobile-large/DP-16750-002.jpg",
        1.33
    ),
    SearchData(
        362,
        249674,
        "Glass pendant shaped like a jug",
        "pendant in the form of a vase|glass|glass",
        "gr/mobile-large/DP121030.jpg",
        0.75
    ),
    SearchData(
        199,
        256774,
        "Marble funerary inscription",
        "plaque with funerary inscription|marble|stone sculpture",
        "gr/mobile-large/DP132690.jpg",
        1.28
    ),
    SearchData(
        349,
        246976,
        "Bronze lampstand",
        "lampstand|bronze|bronzes",
        "gr/mobile-large/DP20382.jpg",
        0.90
    ),
    SearchData(
        149,
        259142,
        "Terracotta mold fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP121117.jpg",
        1.00
    ),
    SearchData(
        25,
        249048,
        "Terracotta atramentarium (inkwell)",
        "inkwell|terracotta|vases",
        "gr/mobile-large/DP107085.jpg",
        1.00
    ),
    SearchData(
        100,
        246704,
        "Bronze strigil",
        "strigil|bronze|bronzes",
        "gr/mobile-large/DP133623.jpg",
        0.75
    ),
    SearchData(
        50,
        255093,
        "Bronze phallic amulet",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20798.jpg",
        1.00
    ),
    SearchData(
        25,
        241979,
        "Marble inscribed block fragment",
        "inscription, fragment|marble, blue gray|cesnola inscriptions",
        "gr/mobile-large/DP132681.jpg",
        1.42
    ),
    SearchData(
        10,
        245827,
        "Glass gold-band mosaic scyphus (drinking cup)",
        "skyphos, gold-band mosaic|glass|glass",
        "gr/mobile-large/DP118055.jpg",
        1.33
    ),
    SearchData(
        115,
        250106,
        "Terracotta jug",
        "jug|terracotta|vases",
        "gr/mobile-large/DP107681.jpg",
        1.00
    ),
    SearchData(
        -50,
        250917,
        "Silver simpulum (ladle)",
        "kyathos|silver|gold and silver",
        "gr/mobile-large/h1_20.49.2-12.jpg",
        1.02
    ),
    SearchData(
        87, 245341,
        "Glass jug",
        "jug|glass|glass",
        "gr/mobile-large/DP107095.jpg",
        1.00,
    ),
    SearchData(
        349,
        245682,
        "Glass beaker",
        "beaker|glass|glass",
        "gr/mobile-large/DP117586.jpg",
        1.00
    ),
    SearchData(
        55,
        250075,
        "Terracotta bowl",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP107068.jpg",
        1.00
    ),
    SearchData(
        100,
        257867,
        "Bronze balsamarium decorated with lion-skins and herms",
        "balsamarium with lion-skins and herms|bronze|bronzes",
        "gr/mobile-large/DP-24426-003.jpg",
        0.72
    ),
    SearchData(
        40,
        253337,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP114270.jpg",
        1.00
    ),
    SearchData(
        -45,
        247008,
        "Wall painting from the west wall of Room L of the Villa of P. Fannius Synistor at Boscoreale",
        "wall painting|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP141474.jpg",
        1.35
    ),
    SearchData(
        232,
        258540,
        "Marble portrait bust of Severus Alexander",
        "portrait bust of severus alexander|marble|stone sculpture",
        "gr/mobile-large/DP345023.jpg",
        0.75
    ),
    SearchData(
        47,
        634951,
        "Porphyry vessel with bearded masks",
        "urn, cinerary|porphyry|miscellaneous-stone vases",
        "gr/mobile-large/DP329148.jpg",
        1.31
    ),
    SearchData(
        199,
        250104,
        "Terracotta jar with barbotine decoration",
        "urn|terracotta|vases",
        "gr/mobile-large/DP121126.jpg",
        1.00
    ),
    SearchData(
        22,
        250120,
        "Terracotta modiolus (drinking cup)",
        "cup, \" modiolus \"|terracotta|vases",
        "gr/mobile-large/DP107076.jpg",
        1.00
    ),
    SearchData(
        140,
        257864,
        "Marble head of Zeus Ammon",
        "head of zeus ammon|marble|stone sculpture",
        "gr/mobile-large/DP265183.jpg",
        0.87
    ),
    SearchData(
        100,
        256652,
        "Bronze statuette of a bull",
        "statuette of a bull|bronze|bronzes",
        "gr/mobile-large/sfx2184.jpg",
        1.18
    ),
    SearchData(
        100,
        251478,
        "Bronze stamp",
        "stamp, inscribed|bronze|bronzes",
        "gr/mobile-large/DP20597.jpg",
        1.15
    ),
    SearchData(
        199,
        245369,
        "Glass flask decorated with intersecting circles",
        "flask|glass|glass",
        "gr/mobile-large/DP107637.jpg",
        1.00
    ),
    SearchData(12, 245719, "Glass bowl", "bowl|glass|glass", "gr/mobile-large/DP121412.jpg", 1.00),
    SearchData(
        100,
        256661,
        "Bronze statuette of bull",
        "statuette of a bull|bronze|bronzes",
        "gr/mobile-large/sfx2197.jpg",
        1.33
    ),
    SearchData(
        249,
        463712,
        "Fragment of a Glass Bowl",
        "bowl fragment|glass, gold leaf|glass-gold glass",
        "md/mobile-large/sf16-174-1s1b.jpg",
        1.18
    ),
    SearchData(
        347,
        252884,
        "Marble portrait head of the Emperor Constantine I",
        "portrait head|marble|stone sculpture",
        "gr/mobile-large/DP138715.jpg",
        0.75
    ),
    SearchData(
        50,
        245743,
        "Glass amphoriskos (perfume flask)",
        "amphoriskos|glass|glass",
        "gr/mobile-large/DP146603.jpg",
        0.75
    ),
    SearchData(
        74,
        250086,
        "Terracotta bowl",
        "plate|terracotta|vases",
        "gr/mobile-large/DP1421.jpg",
        1.00
    ),
    SearchData(
        399,
        256731,
        "Glass bottle",
        "amphoriskos|glass|glass",
        "gr/mobile-large/DP124913.jpg",
        1.00
    ),
    SearchData(
        190,
        250462,
        "Terracotta mortarium fragment",
        "mortarium fragment|terracotta|vases",
        "gr/mobile-large/DP107023.jpg",
        1.00
    ),
    SearchData(
        100,
        257633,
        "Marble torso of Eros",
        "torso of eros|marble|stone sculpture",
        "gr/mobile-large/DP105506.jpg",
        1.00
    ),
    SearchData(
        100,
        250897,
        "Marble statue of a young satyr turning to look at his tail",
        "statue of a faun|marble|stone sculpture",
        "gr/mobile-large/DP326488.jpg",
        0.68
    ),
    SearchData(50, 249015, "Glass pin", "pin|glass|glass", "gr/mobile-large/GR726.jpg", 0.58),
    SearchData(
        25,
        250783,
        "Bronze statuette of a Lar",
        "statuette of a lar|bronze|bronzes",
        "gr/mobile-large/DP-14287-151.jpg",
        0.74
    ),
    SearchData(
        237,
        249032,
        "Ivory pin",
        "pin|ivory|miscellaneous-bone, ivory",
        "gr/mobile-large/DP121008.jpg",
        0.75
    ),
    SearchData(
        -5,
        250945,
        "Wall painting: Perseus and Andromeda in landscape, from the imperial villa at Boscotrecase",
        "wall painting: perseus and andromeda in landscape|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP138761.jpg",
        0.65
    ),
    SearchData(
        0,
        257836,
        "Mosaic glass fragment",
        "fragment, mosaic base ring|glass|glass",
        "gr/mobile-large/DP145723.jpg",
        1.33
    ),
    SearchData(
        50,
        255086,
        "Bronze phallic ornament",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20790.jpg",
        1.00
    ),
    SearchData(
        199,
        256588,
        "Glass ‘Mercury’ bottle fragment",
        "bottle, mercury flask|glass|glass",
        "gr/mobile-large/DP102367.jpg",
        0.94
    ),
    SearchData(
        100,
        256771,
        "Marble plaque with funerary inscription",
        "plaque with funerary inscription|marble|stone sculpture",
        "gr/mobile-large/LC-X_248_1-20200226-06.jpg",
        1.50
    ),
    SearchData(
        50,
        246092,
        "Gold, emerald, carnelian, banded onyx, and garnet necklace",
        "necklace|gold, emerald, carnelian, banded onyx, with central cabochon garnet|gold and silver",
        "gr/mobile-large/SF951613.jpg",
        1.13
    ),
    SearchData(
        199,
        249031,
        "Ivory and gold pin",
        "pin|ivory, gold|miscellaneous-bone, ivory",
        "gr/mobile-large/DP121007.jpg",
        0.75
    ),
    SearchData(
        100,
        249157,
        "Bronze fitting decorated with a bust of Neptune",
        "boat fitting with head of poseidon|bronze|bronzes",
        "gr/mobile-large/DP124614.jpg",
        1.33
    ),
    SearchData(
        125,
        250474,
        "Terracotta jug fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP121120.jpg",
        1.00
    ),
    SearchData(
        149,
        250456,
        "Terracotta lamp handle",
        "lamp handle|terracotta|vases",
        "gr/mobile-large/DP229117.jpg",
        0.75
    ),
    SearchData(
        25,
        249053,
        "Terracotta scyphus (drinking cup)",
        "skyphos|terracotta|vases",
        "gr/mobile-large/DP1442.jpg",
        1.00
    ),
    SearchData(
        100,
        251419,
        "Marble relief fragment with the head of Medea",
        "relief fragment with head of medea|marble|stone sculpture",
        "gr/mobile-large/263089.jpg",
        0.82
    ),
    SearchData(
        55,
        254473,
        "Sardonyx cameo portrait of the Emperor Augustus",
        "cameo, portrait of augustus|sardonyx|gems",
        "gr/mobile-large/DP155547.jpg",
        0.75
    ),
    SearchData(
        87,
        246911,
        "Bronze lamp",
        "lamp|bronze|bronzes",
        "gr/mobile-large/DP20383.jpg",
        0.99
    ),
    SearchData(
        274,
        250419,
        "Terracotta fragment from the rim of a vase",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP229105.jpg",
        1.33
    ),
    SearchData(
        87,
        250927,
        "Marble portrait of a young girl",
        "portrait bust of a woman (domatilla?)|marble|stone sculpture",
        "gr/mobile-large/DP331267.jpg",
        0.75
    ),
    SearchData(
        150,
        250107,
        "Terracotta scyphus (drinking cup)",
        "skyphos|terracotta|vases",
        "gr/mobile-large/DP107682.jpg",
        1.00
    ),
    SearchData(
        350,
        465922,
        "Plate Base with Peregrina between Saints Peter and Paul",
        "bowl bottom|glass, gold leaf|glass-gold glass",
        "md/mobile-large/DP225574.jpg",
        1.07
    ),
    SearchData(
        100,
        246902,
        "Bronze aryballos",
        "bottle|bronze|bronzes",
        "gr/mobile-large/DP20369.jpg",
        0.99
    ),
    SearchData(
        150,
        255880,
        "Gilded bronze mirror with the Three Graces",
        "mirror with three graces|bronze, silver, gold, speculum|bronzes",
        "gr/mobile-large/DT8597.jpg",
        1.25
    ),
    SearchData(
        149,
        250416,
        "Terracotta bowl fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP107022.jpg",
        1.00
    ),
    SearchData(
        -50,
        250912,
        "Four silver spoons",
        "spoons, 4|silver|gold and silver",
        "gr/mobile-large/h1_20.49.2-12.jpg",
        1.02
    ),
    SearchData(
        249,
        257881,
        "Glass snake-thread dropper flask",
        "flask, dropper|glass|glass",
        "gr/mobile-large/DP281260.jpg",
        0.75
    ),
    SearchData(
        180,
        250918,
        "Brass spoon",
        "spoon|[bronze] brass|bronzes",
        "gr/mobile-large/SF204910.jpg",
        1.40
    ),
    SearchData(
        74,
        245371,
        "Glass amphoriskos with horizontal ribs",
        "miniature transport amphora|glass|glass",
        "gr/mobile-large/DP117534.jpg",
        1.00
    ),
    SearchData(
        -45,
        247010,
        "Wall painting from Room H of the Villa of P. Fannius Synistor at Boscoreale",
        "wall painting|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP140600.jpg",
        1.08
    ),
    SearchData(
        0,
        257839,
        "Mosaic glass fragment",
        "fragment, mosaic|glass|glass",
        "gr/mobile-large/DP145722.jpg",
        1.33
    ),
    SearchData(
        34,
        245478,
        "Glass gold-band mosaic bottle",
        "bottle, gold-band mosaic|glass|glass",
        "gr/mobile-large/DP105511.jpg",
        1.00
    ),
    SearchData(
        299,
        256744,
        "Glass bottle",
        "bottle, kuttrolf|glass|glass",
        "gr/mobile-large/DP108414.jpg",
        1.00
    ),
    SearchData(50, 245654, "Glass jug", "jug|glass|glass", "gr/mobile-large/DP117540.jpg", 1.00),
    SearchData(
        50,
        249746,
        "Glass pendant in the form of a leaf",
        "pendant|glass|glass",
        "gr/mobile-large/DP121039.jpg",
        0.75
    ),
    SearchData(
        200,
        250464,
        "Terracotta medallion",
        "medallion, fragment|terracotta|vases",
        "gr/mobile-large/DP105842.jpg",
        1.00
    ),
    SearchData(
        100,
        245501,
        "Bronze mirror handle (?) with Aphrodite",
        "mirror support ? with aphrodite|bronze|bronzes",
        "gr/mobile-large/DP20162.jpg",
        0.99
    ),
    SearchData(
        149,
        251492,
        "Marble statuette of a woman",
        "statuette of a woman|marble, pentelic|stone sculpture",
        "gr/mobile-large/DP271490.jpg",
        0.75
    ),
    SearchData(
        -50,
        250459,
        "Terracotta handle",
        "patera handle|terracotta|vases",
        "gr/mobile-large/DP107059.jpg",
        1.00
    ),
    SearchData(
        100,
        246915,
        "Bronze spout in the form of a Corinthian column",
        "spout in the form of a column|bronze|bronzes",
        "gr/mobile-large/DP20388.jpg",
        0.80
    ),
    SearchData(
        75,
        256735,
        "Glass cup with splayed foot",
        "cup|glass|glass",
        "gr/mobile-large/DP107067.jpg",
        1.00
    ),
    SearchData(
        100,
        253372,
        "Marble statue of Aphrodite, the so-called Venus Genetrix",
        "statue of aphrodite, the so-called venus genetrix type|marble|stone sculpture",
        "gr/mobile-large/DP116947.jpg",
        0.71
    ),
    SearchData(349, 245626, "Glass jug", "jug|glass|glass", "gr/mobile-large/DP304006.jpg", 0.75),
    SearchData(
        100,
        250928,
        "Bronze statuette of Mercury",
        "statuette of hermes|bronze|bronzes",
        "gr/mobile-large/DP20564.jpg",
        0.95
    ),
    SearchData(
        215,
        259248,
        "Marble portrait head of a woman",
        "head of a woman|marble|stone sculpture",
        "gr/mobile-large/DP322106.jpg",
        0.81
    ),
    SearchData(
        25,
        249054,
        "Terracotta scyphus (drinking cup)",
        "skyphos|terracotta|vases",
        "gr/mobile-large/DP107316.jpg",
        1.00
    ),
    SearchData(
        100,
        256650,
        "Bronze statuette of Hercules",
        "statuette of herakles|bronze|bronzes",
        "gr/mobile-large/DP2063.jpg",
        1.00
    ),
    SearchData(
        149,
        245510,
        "Terracotta statuette of Isis or a follower of her cult",
        "statuette of isis|terracotta|terracottas",
        "gr/mobile-large/DP105512.jpg",
        1.00
    ),
    SearchData(
        50,
        251403,
        "Ivory pyxis (box with lid)",
        "pyxis with erotes|ivory|miscellaneous-bone, ivory",
        "gr/mobile-large/DP-14287-004.jpg",
        0.94
    ),
    SearchData(
        100,
        251476,
        "Marble head and torso of Athena",
        "statue of athena, upper part|marble, pentelic|stone sculpture",
        "gr/mobile-large/DP357289.jpg",
        0.75
    ),
    SearchData(
        349,
        255960,
        "Silver mirror",
        "mirror|silver|gold and silver",
        "gr/mobile-large/DP145605.jpg",
        1.00
    ),
    SearchData(
        349,
        249685,
        "Glass pendant in the form of a lamp",
        "pendant in the form of a lamp|glass|glass",
        "gr/mobile-large/DP121032.jpg",
        0.75
    ),
    SearchData(
        149,
        250256,
        "Terracotta flask",
        "vase|terracotta|vases",
        "gr/mobile-large/DP107688.jpg",
        1.00
    ),
    SearchData(
        312,
        241770,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-291.jpg",
        1.05
    ),
    SearchData(
        325,
        465921,
        "Bowl Fragments with Menorah, Shofar, and Torah Ark",
        "bowl fragments|glass, gold leaf|glass-gold glass",
        "md/mobile-large/h1_18.145.1ab.jpg",
        1.28
    ),
    SearchData(
        50,
        253327,
        "Fresco fragment with siren",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP229128.jpg",
        0.75
    ),
    SearchData(
        100,
        251493,
        "Marble head of a Greek general",
        "head of a general (strategos)|marble, pentelic ?|stone sculpture",
        "gr/mobile-large/DP345013.jpg",
        0.75
    ),
    SearchData(
        150,
        250095,
        "Terracotta pyxis (box) with lid",
        "pyxis with lid|terracotta|vases",
        "gr/mobile-large/DP1412.jpg",
        1.00
    ),
    SearchData(
        325,
        466220,
        "Sarcophagus with Scenes from the Lives of Saint Peter and Christ",
        "sarcophagus|marble|sculpture-stone",
        "md/mobile-large/DT6738.jpg",
        2.71
    ),
    SearchData(
        100,
        251415,
        "Marble statuette of a slave boy with a lantern",
        "statuette of a slave with lamp|marble|stone sculpture",
        "gr/mobile-large/DP292010.jpg",
        0.75
    ),
    SearchData(
        100,
        250562,
        "Bronze statuette of a comic actor",
        "statuette of an actor, comic|bronze|bronzes",
        "gr/mobile-large/DP20985.jpg",
        0.99
    ),
    SearchData(
        150,
        257620,
        "Terracotta mold fragment",
        "mold fragment|terracotta|vases",
        "gr/mobile-large/DP121119.jpg",
        1.00
    ),
    SearchData(
        150,
        249020,
        "Gilt bronze strigil",
        "strigil|bronze, gold|bronzes",
        "gr/mobile-large/DP124613.jpg",
        0.75
    ),
    SearchData(
        0,
        257834,
        "Glass striped mosaic fragment",
        "fragment, striped mosaic|glass|glass",
        "gr/mobile-large/DP145732.jpg",
        1.33
    ),
    SearchData(
        220,
        249061,
        "Right corner of a marble sarcophagus with the myth of Apollo and the satyr Marsyas",
        "sarcophagus fragment, apollo and marsyas|marble|stone sculpture",
        "gr/mobile-large/DP-14287-039.jpg",
        0.85
    ),
    SearchData(
        82,
        251838,
        "Fragments of a marble statue of the Diadoumenos (youth tying a fillet around his head)",
        "statue of the diadoumenos, fragmentary|marble|stone sculpture",
        "gr/mobile-large/DT11982.jpg",
        0.73
    ),
    SearchData(
        30,
        257612,
        "Terracotta bowl",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP107027.jpg",
        1.00
    ),
    SearchData(
        149,
        253386,
        "Marble portrait of the emperor Antoninus Pius",
        "portrait head of the emperor antoninus pius|marble|stone sculpture",
        "gr/mobile-large/DP333076.jpg",
        0.75
    ),
    SearchData(
        0,
        257831,
        "Glass mosaic ribbed bowl fragment",
        "fragment, mosaic ribbed bowl rim|glass|glass",
        "gr/mobile-large/DP145729.jpg",
        1.33
    ),
    SearchData(
        100,
        650960,
        "Greywacke plate",
        "plate|greywacke|miscellaneous-stone vases",
        "gr/mobile-large/DP700676.jpg",
        1.26
    ),
    SearchData(
        312,
        468759,
        "Table Base with Jonah Swallowed and Cast Up by the Big Fish",
        "sculpture|marble, white|sculpture-stone",
        "md/mobile-large/DT234784.jpg",
        1.25
    ),
    SearchData(
        -5,
        250931,
        "Wall painting on black ground: Egyptianizing scene and pair of swans, from the imperial villa at Boscotrecase",
        "wall painting on black ground: egyptianizing scene and pair of swans|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP144211.jpg",
        1.00
    ),
    SearchData(
        349,
        245717,
        "Glass flask",
        "bottle with engraved lines|glass|glass",
        "gr/mobile-large/DP304007.jpg",
        0.75
    ),
    SearchData(
        50,
        251412,
        "Bronze furniture attachment",
        "furniture attachment, head of a mule|bronze|bronzes",
        "gr/mobile-large/DP20617.jpg",
        0.98
    ),
    SearchData(
        50,
        250954,
        "Statue of a boy",
        "statuette of a youth|bekhen stone|stone sculpture",
        "gr/mobile-large/DP-23278-001.jpg",
        0.75
    ),
    SearchData(
        150,
        250089,
        "Terracotta bowl",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP1400.jpg",
        1.00
    ),
    SearchData(
        325,
        258076,
        "Glass bowl in the form of a shell",
        "bowl|glass|glass",
        "gr/mobile-large/DP153111.jpg",
        1.00
    ),
    SearchData(
        149,
        248175,
        "Stucco relief fragment",
        "relief of emperor antoninus pius and a barbarian suppliant|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP105599.jpg",
        1.00
    ),
    SearchData(
        265,
        254819,
        "Marble sarcophagus with the Triumph of Dionysos and the Seasons",
        "sarcophagus, triumph of dionysos and the seasons|marble|stone sculpture",
        "gr/mobile-large/DP-14287-144.jpg",
        0.87
    ),
    SearchData(
        40,
        253326,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112915.jpg",
        1.00
    ),
    SearchData(
        50,
        246917,
        "Bronze handle of a patera (shallow saucepan)",
        "handle of a patera with wolf|bronze|bronzes",
        "gr/mobile-large/DP133619.jpg",
        1.33
    ),
    SearchData(
        10,
        248973,
        "Glass ribbed bowl",
        "bowl, ribbed|glass|glass",
        "gr/mobile-large/DP120951.jpg",
        1.00
    ),
    SearchData(
        185,
        250099,
        "Terracotta indented beaker",
        "beaker|terracotta indented beaker, probably made at trier|vases",
        "gr/mobile-large/DP1288.jpg",
        1.00
    ),
    SearchData(
        449,
        241592,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-244.jpg",
        1.05
    ),
    SearchData(
        -13,
        248466,
        "Bronze statuette of a philosopher on a lamp stand",
        "statuette of philosopher on lamp stand, hermarchos ?|bronze|bronzes",
        "gr/mobile-large/DP337221.jpg",
        0.75
    ),
    SearchData(
        25,
        241722,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-186.jpg",
        0.91
    ),
    SearchData(
        100,
        250955,
        "Bronze statuette of Hermes seated on a rock",
        "statuette of hermes holding a purse|bronze|bronzes",
        "gr/mobile-large/DP20561.jpg",
        0.95
    ),
    SearchData(
        95,
        250105,
        "Terracotta oil lamp",
        "lamp, glazed|terracotta|terracottas",
        "gr/mobile-large/DP229109.jpg",
        1.33
    ),
    SearchData(
        100,
        250142,
        "Glass head of Zeus Sarapis",
        "head of zeus sarapis|glass|glass",
        "gr/mobile-large/DP121791.jpg",
        1.00
    ),
    SearchData(
        199,
        256823,
        "Bronze steelyard weight",
        "weight, bust of isis|bronze|bronzes",
        "gr/mobile-large/DP2088.jpg",
        1.00
    ),
    SearchData(
        325,
        250141,
        "Glass portrait head",
        "head of a man|glass|glass",
        "gr/mobile-large/DP141538.jpg",
        1.00
    ),
    SearchData(
        449,
        246909,
        "Bronze steelyard and weight",
        "steelyard|bronze|bronzes",
        "gr/mobile-large/DP20386.jpg",
        1.26
    ),
    SearchData(349, 258494, "Glass dish", "dish|glass|glass", "gr/mobile-large/DP228638.jpg", 1.58),
    SearchData(
        220,
        257781,
        "Marble strigilated sarcophagus",
        "sarcophagus, strigilated|marble|stone sculpture",
        "gr/mobile-large/DP130701.jpg",
        1.38
    ),
    SearchData(
        149,
        251414,
        "Marble relief of a chisel and mallet",
        "relief of a mallet and chisel|marble-italian ?|stone sculpture",
        "gr/mobile-large/LC-23_160_81.jpg",
        0.85
    ),
    SearchData(
        50,
        250983,
        "Gold and pearl earring",
        "earring with pearl pendants|gold, pearl|gold and silver",
        "gr/mobile-large/SF20234235.jpg",
        1.31
    ),
    SearchData(
        87,
        245683,
        "Glass bottle shaped like a date",
        "flask in the form of a date|glass|glass",
        "gr/mobile-large/DP121411.jpg",
        1.00
    ),
    SearchData(
        25,
        249176,
        "Terracotta bowl",
        "bowl, footed|terracotta|vases",
        "gr/mobile-large/DP105600.jpg",
        1.00
    ),
    SearchData(
        249,
        245390,
        "Glass plate with head of Medusa",
        "plate with head of medusa|glass|glass",
        "gr/mobile-large/GR762.jpg",
        1.65
    ),
    SearchData(
        0,
        257835,
        "Network mosaic glass fragment",
        "mosaic glass fragment|glass|glass",
        "gr/mobile-large/DP145733.jpg",
        0.75
    ),
    SearchData(
        22,
        250118,
        "Terracotta scyphus (drinking cup)",
        "skyphos|terracotta|vases",
        "gr/mobile-large/DP107075.jpg",
        1.00
    ),
    SearchData(
        199,
        468362,
        "Brooch in the Form of a Peacock",
        "brooch|champlevé enamel, bronze, garnet cabochon|enamels-champlevé",
        "md/mobile-large/sf51-125-1s1.jpg",
        0.75
    ),
    SearchData(
        25,
        245495,
        "Glass cameo cup fragment",
        "cameo cup fragment, symplegma|glass|glass",
        "gr/mobile-large/DT12101.jpg",
        0.79
    ),
    SearchData(
        249,
        245815,
        "Glass finger ring",
        "ring|glass|glass",
        "gr/mobile-large/DP121097.jpg",
        0.75
    ),
    SearchData(
        75,
        250248,
        "Terracotta bowl",
        "dish|terracotta|vases",
        "gr/mobile-large/DP1418.jpg",
        1.00
    ),
    SearchData(
        0,
        257639,
        "Bronze torso from an equestrian statue wearing a cuirass",
        "torso from an equestrian statue wearing a cuirass|bronze|bronzes",
        "gr/mobile-large/DP108187.jpg",
        1.00
    ),
    SearchData(
        100,
        250566,
        "Bronze statuette of Jupiter Capitolinus",
        "statuette of jupiter capitolinus|bronze|bronzes",
        "gr/mobile-large/DP161809.jpg",
        1.00
    ),
    SearchData(
        13,
        245631,
        "Glass beaker",
        "beaker|glass, cast|glass",
        "gr/mobile-large/SF9111238color.jpg",
        0.88
    ),
    SearchData(
        249,
        245744,
        "Glass double head-shaped flask",
        "flask, double head-shaped|glass|glass",
        "gr/mobile-large/DP107639.jpg",
        1.00
    ),
    SearchData(
        100,
        256772,
        "Marble plaque with funerary inscription",
        "plaque with funerary inscription|marble|stone sculpture",
        "gr/mobile-large/LC-X_248_2-20200226-06.jpg",
        1.50
    ),
    SearchData(
        149,
        250556,
        "Marble torso of a youth",
        "statue of a youth, torso|marble|stone sculpture",
        "gr/mobile-large/DP-14287-141.jpg",
        0.75
    ),
    SearchData(
        195,
        250351,
        "Fragment of terra sigillata",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP107020.jpg",
        1.00
    ),
    SearchData(
        215,
        245931,
        "Gold and beryl ring",
        "ring|gold, beryl|gold and silver",
        "gr/mobile-large/sf9515131edited.jpg",
        1.33
    ),
    SearchData(
        149,
        257626,
        "Marble cornice fragment",
        "architectural fragment|marble|stone sculpture",
        "gr/mobile-large/sf2002603.jpg",
        1.83
    ),
    SearchData(
        99,
        251475,
        "Marble torso of Eros",
        "statue of eros, fragmentary|marble|stone sculpture",
        "gr/mobile-large/59444.jpg",
        0.78
    ),
    SearchData(
        50,
        255869,
        "Bronze lamp",
        "lamp|bronze|bronzes",
        "gr/mobile-large/DP20848.jpg",
        1.00
    ),
    SearchData(
        25,
        257725,
        "Bone pyxis (box with lid)",
        "pyxis with lid|bone|miscellaneous-bone, ivory",
        "gr/mobile-large/SF2004507abedited.jpg",
        1.17
    ),
    SearchData(
        25,
        247993,
        "Marble portrait of the emperor Augustus",
        "portrait head of the emperor augustus|marble|stone sculpture",
        "gr/mobile-large/DP337220.jpg",
        0.75
    ),
    SearchData(
        562,
        245304,
        "Glass weight",
        "weight|glass|glass",
        "gr/mobile-large/DP121465.jpg",
        1.00
    ),
    SearchData(
        25,
        245493,
        "Glass cameo fragment of a large platter or tabletop",
        "cameo, platter fragment|glass|glass",
        "gr/mobile-large/DP118115.jpg",
        1.68
    ),
    SearchData(
        150,
        253037,
        "Terracotta fragment of a bowl",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP105846.jpg",
        1.00
    ),
    SearchData(
        50,
        241623,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-252.jpg",
        1.05
    ),
    SearchData(
        50,
        250504,
        "Fragmentary terracotta bowl",
        "cup, fragment|terracotta|vases",
        "gr/mobile-large/DP121123.jpg",
        1.00
    ),
    SearchData(
        15,
        250776,
        "Terracotta cup",
        "cup, fragment|terracotta|vases",
        "gr/mobile-large/DP1415.jpg",
        1.00
    ),
    SearchData(
        149,
        250257,
        "Terracotta rattle in the form of a pig",
        "rattle in the form of a pig|terracotta, glass|terracottas",
        "gr/mobile-large/DP2031.jpg",
        1.00
    ),
    SearchData(
        12,
        257827,
        "Mosaic glass fragment",
        "mosaic glass fragment|glass|glass",
        "gr/mobile-large/DP145725.jpg",
        1.33
    ),
    SearchData(
        41,
        245849,
        "Wall painting fragment with a swan",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112922.jpg",
        1.00
    ),
    SearchData(
        212,
        256758,
        "Marble portrait head of a woman",
        "portrait bust of a woman|marble|stone sculpture",
        "gr/mobile-large/DP333686.jpg",
        0.75
    ),
    SearchData(
        499,
        245521,
        "Terracotta statuette of a bear holding an oil lamp",
        "statuette of a bear holding lamp|terracotta|terracottas",
        "gr/mobile-large/DP145569.jpg",
        0.74
    ),
    SearchData(
        100,
        251460,
        "Marble statuette of a seated philosopher",
        "statuette of a philosopher|marble|stone sculpture",
        "gr/mobile-large/DP338143.jpg",
        0.75
    ),
    SearchData(
        -5,
        250939,
        "Wall painting on black ground: landscape, from the imperial villa at Boscotrecase",
        "wall painting on black ground: landscape|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP146610.jpg",
        1.00
    ),
    SearchData(
        100,
        250787,
        "Bronze statuette of Cupid",
        "statuette of cupid|bronze|bronzes",
        "gr/mobile-large/DP20573.jpg",
        0.93
    ),
    SearchData(
        25,
        245363,
        "Glass beaker with inscription",
        "beaker, inscribed|glass|glass",
        "gr/mobile-large/DP120990.jpg",
        1.00
    ),
    SearchData(
        249,
        256732,
        "Glass bottle shaped like a bunch of grapes",
        "bottle with stylized grape cluster|glass|glass",
        "gr/mobile-large/DP108406.jpg",
        1.00
    ),
    SearchData(
        149,
        250242,
        "Fragmentary terracotta cup",
        "cup, fragmentary|terracotta|vases",
        "gr/mobile-large/DP121114.jpg",
        1.00
    ),
    SearchData(
        195,
        250350,
        "Fragment of terra sigillata",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP107019.jpg",
        1.00
    ),
    SearchData(
        74,
        245836,
        "Stucco relief panel",
        "stucco relief of maenad|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-077.jpg",
        1.13
    ),
    SearchData(
        50,
        245734,
        "Glass ribbed bowl",
        "bowl, rippenschale|glass|glass",
        "gr/mobile-large/DP107100.jpg",
        1.00
    ),
    SearchData(
        0,
        257833,
        "Glass mosaic base ring fragment",
        "fragment, mosaic|glass|glass",
        "gr/mobile-large/DP145731.jpg",
        1.33
    ),
    SearchData(
        100,
        246992,
        "Marble head of a Hellenistic ruler",
        "head of a youth|marble|stone sculpture",
        "gr/mobile-large/DP119205.jpg",
        0.71
    ),
    SearchData(
        37,
        250540,
        "Bronze bust of Jupiter",
        "bust of zeus|bronze, copper|bronzes",
        "gr/mobile-large/DP-12522-001.jpg",
        1.00
    ),
    SearchData(
        249,
        257875,
        "Glass snake-thread flask shaped like a mouse",
        "flask, snake-thread mouse-shaped|glass, blue|glass",
        "gr/mobile-large/DP286317.jpg",
        1.33
    ),
    SearchData(
        25,
        246266,
        "Marble cinerary chest with lid",
        "cippus of lucius gavius (funerary chest)|marble|stone sculpture",
        "gr/mobile-large/47477.jpg",
        0.94
    ),
    SearchData(
        74,
        245834,
        "Stucco relief panel",
        "stucco relief|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-073.jpg",
        0.83
    ),
    SearchData(
        50,
        250586,
        "Miniature amber amphora (jar)",
        "amphora, miniature|amber|miscellaneous-amber",
        "gr/mobile-large/SF1723053edited.jpg",
        1.08
    ),
    SearchData(
        -45,
        247017,
        "Cubiculum (bedroom) from the Villa of P. Fannius Synistor at Boscoreale",
        "cubiculum (bedroom) from the villa of p. fannius synistor|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP143704.jpg",
        1.04
    ),
    SearchData(
        212,
        239584,
        "Marble sarcophagus with garlands",
        "sarcophagus, garland|marble, proconnesian|stone sculpture",
        "gr/mobile-large/DP140135.jpg",
        1.45
    ),
    SearchData(
        449,
        245695,
        "Glass bottle",
        "bottle|glass|glass",
        "gr/mobile-large/DP121451.jpg",
        1.00
    ),
    SearchData(
        214,
        253592,
        "Marble portrait of the emperor Caracalla",
        "portrait head of the emperor marcus aurelius antoninus (called caracalla)|marble|stone sculpture",
        "gr/mobile-large/DP333080.jpg",
        0.75
    ),
    SearchData(
        149,
        249051,
        "Marble portrait of a man",
        "portrait bust of a man|marble|stone sculpture",
        "gr/mobile-large/DP344994.jpg",
        0.75
    ),
    SearchData(
        -5,
        250933,
        "Wall painting on black ground: supports with entrablature, from the imperial villa at Boscotrecase",
        "wall painting on black ground: supports with entablature|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP146615.jpg",
        1.00
    ),
    SearchData(
        50,
        255089,
        "Bronze phallic amulet",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20802.jpg",
        1.01
    ),
    SearchData(
        180,
        250519,
        "Terracotta relief from a lamp with Leda and the swan",
        "lamp relief fragment|terracotta|terracottas",
        "gr/mobile-large/DP229108.jpg",
        0.75
    ),
    SearchData(
        105,
        250094,
        "Terracotta plate",
        "plate|terracotta|vases",
        "gr/mobile-large/DP107081.jpg",
        1.00
    ),
    SearchData(
        12,
        257830,
        "Glass striped mosaic fragment",
        "fragment, striped mosaic, quadripartite|glass|glass",
        "gr/mobile-large/DP145728.jpg",
        0.75
    ),
    SearchData(
        399,
        256712,
        "Glass jug with trefoil rim",
        "jug with trefoil rim|glass|glass",
        "gr/mobile-large/DP117557.jpg",
        1.00
    ),
    SearchData(
        149,
        468473,
        "Bow Brooch",
        "brooch|champlevé enamel, bronze|enamels-champlevé",
        "md/mobile-large/sf55-140s4.jpg",
        0.60
    ),
    SearchData(
        199,
        245344,
        "Glass spouted jug",
        "jug|glass|glass",
        "gr/mobile-large/DP107636.jpg",
        1.00
    ),
    SearchData(
        87,
        251452,
        "Glass cinerary urn with lid",
        "urn with two handles and lid|glass|glass",
        "gr/mobile-large/DP107323.jpg",
        1.00
    ),
    SearchData(
        84,
        250234,
        "Terracotta strainer jug",
        "vase|terracotta|vases",
        "gr/mobile-large/DP107686.jpg",
        1.00
    ),
    SearchData(
        145,
        241809,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-183.jpg",
        0.88
    ),
    SearchData(
        249,
        246849,
        "Silver bracelet in the form of a snake",
        "bracelet with snakes\" heads|silver|gold and silver",
        "gr/mobile-large/DP136030.jpg",
        1.33
    ),
    SearchData(
        350,
        473395,
        "Lute",
        "lute|wood with traces of paint|woodwork-miscellany",
        "md/mobile-large/DP302641.jpg",
        1.33
    ),
    SearchData(
        150,
        246760,
        "Pair of gold earrings",
        "earring|gold|gold and silver",
        "gr/mobile-large/DP136021.jpg",
        1.33
    ),
    SearchData(
        150,
        250241,
        "Terracotta jar with barbotine decoration",
        "vase|terracotta|vases",
        "gr/mobile-large/DP107687.jpg",
        1.00
    ),
    SearchData(
        537,
        241597,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP105613.jpg",
        1.00
    ),
    SearchData(
        100,
        250623,
        "Bronze specillum (probe)",
        "spatula|bronze|bronzes",
        "gr/mobile-large/DP20539.jpg",
        1.41
    ),
    SearchData(
        34,
        249623,
        "Glass and gold inlay",
        "mosaic block inlay|glass|glass",
        "gr/mobile-large/sf17194387color.jpg",
        1.05
    ),
    SearchData(
        50,
        255090,
        "Bronze phallic amulet",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20803.jpg",
        1.00
    ),
    SearchData(
        50,
        255094,
        "Bronze phallic ornament",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20797.jpg",
        1.00
    ),
    SearchData(
        0,
        259216,
        "Marble pillar with Neo-Attic reliefs",
        "pillar|marble|stone sculpture",
        "gr/mobile-large/DP325731.jpg",
        0.55
    ),
    SearchData(
        252,
        247117,
        "Bronze statue of the emperor Trebonianus Gallus",
        "statue of emperor trebonianus gallus|bronze|bronzes",
        "gr/mobile-large/DP138716.jpg",
        0.75
    ),
    SearchData(
        50,
        253355,
        "Plaster relief fragment with a male figure on a throne",
        "mold of ancient casts for metal reliefs|plaster|miscellaneous-plaster",
        "gr/mobile-large/sf311116.jpg",
        1.33
    ),
    SearchData(
        50,
        253354,
        "Plaster relief fragment with a male figure on a throne",
        "mold of ancient casts for metal reliefs|plaster|miscellaneous-plaster",
        "gr/mobile-large/DP146294.jpg",
        0.75
    ),
    SearchData(
        74,
        245837,
        "Stucco relief panel",
        "stucco relief|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-080.jpg",
        1.07
    ),
    SearchData(
        349,
        249676,
        "Glass pendant shaped like a jug",
        "pendant in the form of a vase|glass|glass",
        "gr/mobile-large/DP124931.jpg",
        0.75
    ),
    SearchData(
        20,
        255973,
        "Statue of Dionysos leaning on a female figure (\"Hope Dionysos\")",
        "statue of dionysos leaning on a female figure (\"hope dionysos\")|marble|stone sculpture",
        "gr/mobile-large/DT6494.jpg",
        0.80
    ),
    SearchData(
        115,
        250109,
        "Terracotta lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP105840.jpg",
        1.00
    ),
    SearchData(
        74,
        245839,
        "Stucco relief panel",
        "stucco relief|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-079.jpg",
        1.37
    ),
    SearchData(
        399,
        256746,
        "Glass bottle",
        "bottle|glass|glass",
        "gr/mobile-large/DP117554.jpg",
        1.00
    ),
    SearchData(
        349,
        245720,
        "Glass beaker",
        "beaker|glass|glass",
        "gr/mobile-large/DP141536.jpg",
        1.00
    ),
    SearchData(
        50,
        245381,
        "Glass bottle",
        "bottle|glass|glass",
        "gr/mobile-large/DP107097.jpg",
        1.00
    ),
    SearchData(
        75,
        245378,
        "Glass cup in the form of the head of a Black African",
        "cup in the form of a head of a african|glass|glass",
        "gr/mobile-large/DP118340.jpg",
        1.00
    ),
    SearchData(
        150,
        250123,
        "Glass bowl fragment with later inscription",
        "bowl fragment|glass|glass",
        "gr/mobile-large/DP166246.jpg",
        1.00
    ),
    SearchData(
        252,
        247169,
        "Bronze sestertius of Trebonianus Gallus",
        "sestertius|bronze|coins",
        "gr/mobile-large/DP104783.jpg",
        1.00
    ),
    SearchData(
        100,
        246708,
        "Pair of gold boat-shaped earrings",
        "earring, pair|gold|gold and silver",
        "gr/mobile-large/DP136022.jpg",
        1.33
    ),
    SearchData(
        349,
        245689,
        "Glass flask",
        "flask, globular|glass|glass",
        "gr/mobile-large/DP121450.jpg",
        1.00
    ),
    SearchData(
        50,
        250139,
        "Ivory hairpin",
        "pin|ivory|miscellaneous-bone, ivory",
        "gr/mobile-large/DP121059.jpg",
        0.75
    ),
    SearchData(
        149,
        465900,
        "Brooch in the Form of a Dog",
        "brooch|champlevé enamel, bronze|enamels-champlevé",
        "md/mobile-large/sf17-194-2390s1.jpg",
        1.79
    ),
    SearchData(
        249,
        245358,
        "Glass indented jar",
        "jar, indented|glass|glass",
        "gr/mobile-large/DP117533.jpg",
        1.00
    ),
    SearchData(
        50,
        245370,
        "Glass hexagonal jug",
        "jug, hexagonal|glass|glass",
        "gr/mobile-large/DP120993.jpg",
        1.00
    ),
    SearchData(
        74,
        245833,
        "Stucco relief panel",
        "stucco relief|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-074.jpg",
        0.89
    ),
    SearchData(
        100,
        256660,
        "Bronze statuette of a goose",
        "statuette of a goose|bronze|bronzes",
        "gr/mobile-large/sfx2196.jpg",
        1.33
    ),
    SearchData(
        40,
        253334,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP114268.jpg",
        1.00
    ),
    SearchData(
        85,
        250909,
        "Terracotta one-handled cup",
        "cup, one-handled|terracotta|vases",
        "gr/mobile-large/DP1463.jpg",
        1.00
    ),
    SearchData(
        50,
        255010,
        "Bronze bust of an Amazon",
        "bust of amazon|bronze|bronzes",
        "gr/mobile-large/DP20780.jpg",
        1.00
    ),
    SearchData(
        50,
        245374,
        "Glass beaker",
        "beaker|glass|glass",
        "gr/mobile-large/DP107096.jpg",
        1.00
    ),
    SearchData(
        1,
        257877,
        "Glass ribbed bowl",
        "bowl, ribbed|glass|glass",
        "gr/mobile-large/DP281252.jpg",
        1.44
    ),
    SearchData(
        149,
        256126,
        "Porphyry support for a water basin",
        "stand for a basin|porphyry|stone sculpture",
        "gr/mobile-large/DP-14287-132.jpg",
        1.71
    ),
    SearchData(
        150,
        250093,
        "Terracotta plate",
        "plate|terracotta|vases",
        "gr/mobile-large/DP107080.JPG",
        1.00
    ),
    SearchData(
        40,
        253335,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP114269.jpg",
        1.00
    ),
    SearchData(
        25,
        245367,
        "Glass beaker with inscription",
        "beaker, inscribed|glass|glass",
        "gr/mobile-large/DP120992.jpg",
        1.00
    ),
    SearchData(
        49,
        241656,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-19673-097.jpg",
        1.06
    ),
    SearchData(
        0,
        257832,
        "Glass striped mosaic fragment",
        "fragment, striped mosaic|glass|glass",
        "gr/mobile-large/DP145730.jpg",
        1.33
    ),
    SearchData(
        -112,
        246594,
        "Terracotta Megarian bowl",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP1297.jpg",
        1.00
    ),
    SearchData(
        100,
        246676,
        "Bronze ladle",
        "ladle|bronze|bronzes",
        "gr/mobile-large/DP20324.jpg",
        0.95
    ),
    SearchData(
        100,
        245503,
        "Bronze ring with bust of Serapis",
        "ring with bust of serapis|bronze|bronzes",
        "gr/mobile-large/sf892558.jpg",
        0.93
    ),
    SearchData(
        50,
        255088,
        "Bronze phallic amulet",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20801.jpg",
        1.01
    ),
    SearchData(
        149,
        256778,
        "Marble head of a woman",
        "portrait head of a woman|marble|stone sculpture",
        "gr/mobile-large/DP333689.jpg",
        0.75
    ),
    SearchData(
        50,
        250188,
        "Terracotta vase fragment with relief of Minerva",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP105601.jpg",
        1.00
    ),
    SearchData(
        1,
        258555,
        "Marble statuette of young Dionysos",
        "torso of dionysos|marble|stone sculpture",
        "gr/mobile-large/DP265186.jpg",
        0.79
    ),
    SearchData(
        50,
        254841,
        "Bronze fulcrum attachment with a bust of Eros",
        "furniture attachment from a couch, eros|bronze|bronzes",
        "gr/mobile-large/DP20784.jpg",
        1.00
    ),
    SearchData(
        212,
        256773,
        "Marble funerary inscription",
        "plaque with funerary inscription|marble|stone sculpture",
        "gr/mobile-large/DP132689.jpg",
        1.26
    ),
    SearchData(
        200,
        250326,
        "Terracotta medallion fragment",
        "medallion, fragment|terracotta|vases",
        "gr/mobile-large/DP107078.jpg",
        1.00
    ),
    SearchData(
        199,
        245840,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP145600.jpg",
        1.00
    ),
    SearchData(
        34,
        249624,
        "Glass mosaic inlay fragments",
        "mosaic block inlay|glass|glass",
        "gr/mobile-large/sf17194388a-c_edited.jpg",
        1.60
    ),
    SearchData(
        100,
        250492,
        "Terracotta vase fragment with figure of Hercules",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP105602.jpg",
        1.00
    ),
    SearchData(
        162,
        247524,
        "Silver handle of a large dish",
        "handle of a large dish|silver, gold|gold and silver",
        "gr/mobile-large/DP107034.jpg",
        1.00
    ),
    SearchData(
        200,
        466382,
        "Disk Brooch",
        "brooch|champlevé enamel, bronze|enamels-champlevé",
        "md/mobile-large/sf22-50-11s1.jpg",
        1.09
    ),
    SearchData(
        199,
        466218,
        "S-Shaped Brooch",
        "brooch|bronze|metalwork-bronze",
        "md/mobile-large/MED150.jpg",
        0.72
    ),
    SearchData(
        299,
        249669,
        "Glass pendant shaped like a jar",
        "pendant|glass|glass",
        "gr/mobile-large/DP121028.jpg",
        0.75
    ),
    SearchData(
        75,
        245685,
        "Glass cinerary urn with lid",
        "urn with two handles and lid|glass|glass",
        "gr/mobile-large/DP109362.jpg",
        1.00
    ),
    SearchData(
        99,
        250929,
        "Limestone torso of a hunter",
        "torso of a hunter, fragmentary|black limestone|stone sculpture",
        "gr/mobile-large/DP279059.jpg",
        0.75
    ),
    SearchData(
        100,
        251431,
        "Amber disk with a nereid riding a triton",
        "disk|amber|miscellaneous-amber",
        "gr/mobile-large/SF2316098color.jpg",
        1.08
    ),
    SearchData(
        50,
        255087,
        "Bronze phallic amulet",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20800.jpg",
        1.01
    ),
    SearchData(
        55,
        245636,
        "Glass ribbed bowl",
        "bowl, rippenschale|glass|glass",
        "gr/mobile-large/DP107098.jpg",
        1.00
    ),
    SearchData(
        99,
        250899,
        "Marble torso of a seated man",
        "torso of a youth, fragmentary|marble|stone sculpture",
        "gr/mobile-large/120133.jpg",
        0.67
    ),
    SearchData(
        149,
        250784,
        "Bronze statuette of Minerva",
        "statuette of athena|bronze|bronzes",
        "gr/mobile-large/DP-14972-001.jpg",
        0.79
    ),
    SearchData(
        199,
        250904,
        "Fragmentary porphyry  head of a bearded man",
        "head of a man|porphyry|stone sculpture",
        "gr/mobile-large/DP202796.jpg",
        1.00
    ),
    SearchData(
        40,
        253338,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP114271.jpg",
        1.00
    ),
    SearchData(
        100,
        250564,
        "Bronze footed globular vessel with lid",
        "pyxis with lid|bronze|bronzes",
        "gr/mobile-large/DP21061.jpg",
        0.99
    ),
    SearchData(
        299,
        250487,
        "Glass bowl fragment with gold leaf and painted decoration",
        "bowl with gilding-gold leaf; ocean|glass, gold, paint|glass",
        "gr/mobile-large/DP107355.jpg",
        1.00
    ),
    SearchData(
        199,
        250734,
        "Glass jug decorated with intersecting circles",
        "jug|glass|glass",
        "gr/mobile-large/DP107001.jpg",
        1.00
    ),
    SearchData(
        100,
        246908,
        "Bronze batillum (incense shovel)",
        "shovel|bronze|bronzes",
        "gr/mobile-large/DP20385.jpg",
        1.35
    ),
    SearchData(
        275,
        466645,
        "Medallion with a Portrait of Gennadios",
        "medallion|glass, gold leaf, polychromy|glass-gold glass",
        "md/mobile-large/DP325825.jpg",
        0.99
    ),
    SearchData(
        300,
        253369,
        "Fragmentary marble votive altar",
        "votive relief fragment, inscription|marble|stone sculpture",
        "gr/mobile-large/DP145791.jpg",
        0.71
    ),
    SearchData(
        150,
        469961,
        "Wing Brooch",
        "brooch|silver, gold, four carnelians|metalwork-silver",
        "md/mobile-large/DT108.jpg",
        0.80
    ),
    SearchData(50, 245709, "Glass jug", "jug|glass|glass", "gr/mobile-large/DP117541.jpg", 1.00),
    SearchData(
        100,
        246904,
        "Bronze aryballos",
        "bottle|bronze|bronzes",
        "gr/mobile-large/DP20368.jpg",
        0.99
    ),
    SearchData(
        399,
        245314,
        "Glass pendant in the form of a miniature jug",
        "pendant in the form of a miniature jug|glass|glass",
        "gr/mobile-large/DP121094.jpg",
        0.75
    ),
    SearchData(
        390,
        250383,
        "Terracotta bowl fragment",
        "bowl fragment|terracotta|vases",
        "gr/mobile-large/DP121116.jpg",
        1.00
    ),
    SearchData(
        61,
        250078,
        "Terracotta marbled slip ware bowl",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP107069.jpg",
        1.00
    ),
    SearchData(
        40,
        245845,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112918.jpg",
        1.00
    ),
    SearchData(
        75,
        250082,
        "Terracotta amphora (jar)",
        "amphora|terracotta|vases",
        "gr/mobile-large/DP107070.jpg",
        1.00
    ),
    SearchData(
        299,
        466585,
        "Fragment of a Sarcophagus with Putti in a Grapevine",
        "relief|marble|sculpture-stone",
        "md/mobile-large/sf24-97-12s1.jpg",
        1.41
    ),
    SearchData(
        15,
        250119,
        "Terracotta beaker",
        "cup|terracotta|vases",
        "gr/mobile-large/SF17194895b.jpg",
        0.80
    ),
    SearchData(
        40,
        247173,
        "Marble statue of Eirene (the personification of peace)",
        "statue of eirene|marble, pentelic ?|stone sculpture",
        "gr/mobile-large/DT11659.jpg",
        0.73
    ),
    SearchData(
        297,
        245923,
        "Gold crossbow fibula (brooch)",
        "fibula, crossbow type|gold|gold and silver",
        "gr/mobile-large/DP107033.jpg",
        1.00
    ),
    SearchData(
        149,
        251474,
        "Marble sarcophagus with the myth of Endymion",
        "sarcophagus, endymion|marble|stone sculpture",
        "gr/mobile-large/DP-14287-043.jpg",
        2.00
    ),
    SearchData(
        100,
        246910,
        "Ring for the attachment of bath implements",
        "ring with lions|bronze|bronzes",
        "gr/mobile-large/DP20389.jpg",
        1.06
    ),
    SearchData(
        -6,
        246657,
        "Terracotta antefix",
        "antefix with venus and mars|terracotta|terracottas",
        "gr/mobile-large/DP-14287-052.jpg",
        0.83
    ),
    SearchData(
        0,
        257837,
        "Mosaic glass fragment",
        "mosaic glass fragment|glass|glass",
        "gr/mobile-large/DP145734.jpg",
        0.75
    ),
    SearchData(
        149,
        256403,
        "Marble Statue Group of the Three Graces",
        "statue group of the three graces|marble|stone sculpture",
        "gr/mobile-large/DP222664.jpg",
        1.21
    ),
    SearchData(
        -5,
        250930,
        "Wall painting on black ground: Aedicula with small landscape, from the imperial villa at Boscotrecase",
        "wall painting on black ground: aedicula with small landscape|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP144209.jpg",
        1.00
    ),
    SearchData(
        350,
        245345,
        "Glass beaker",
        "beaker|glass|glass",
        "gr/mobile-large/DP107004.jpg",
        1.00
    ),
    SearchData(
        149,
        245730,
        "Glass beaker with facet-cut decoration",
        "beaker|glass|glass",
        "gr/mobile-large/DP117542.jpg",
        1.00
    ),
    SearchData(
        0,
        256184,
        "Pair of silver scyphi (cups) with relief decoration",
        "skyphoi with erotes, pair|silver with gilding|gold and silver",
        "gr/mobile-large/gr1994.43.1-.2.R.jpg",
        1.61
    ),
    SearchData(
        74,
        245835,
        "Stucco relief panel",
        "stucco relief|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-078.jpg",
        0.87
    ),
    SearchData(
        199,
        468713,
        "Disk Brooch",
        "brooch|millefiore enamel, bronze|enamels-champlevé",
        "md/mobile-large/sf66-16s1.jpg",
        1.02
    ),
    SearchData(
        50,
        245737,
        "Glass ribbed bottle",
        "flask|glass|glass",
        "gr/mobile-large/DP121000.jpg",
        1.00
    ),
    SearchData(
        170,
        250352,
        "Fragment of terra sigillata",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP107021.jpg",
        1.00
    ),
    SearchData(
        -6,
        248891,
        "Bronze statue of an aristocratic boy",
        "statue of a boy, gaius caesar ?|bronze|bronzes",
        "gr/mobile-large/DP345062.jpg",
        0.75
    ),
    SearchData(
        -50,
        250920,
        "Silver cochlear (spoon)",
        "spoon, cochlear|silver|gold and silver",
        "gr/mobile-large/DT277656.jpg",
        0.80
    ),
    SearchData(
        50,
        253353,
        "Circular plaster relief",
        "mold of ancient casts for metal reliefs|plaster|miscellaneous-plaster",
        "gr/mobile-large/sf311115.jpg",
        1.33
    ),
    SearchData(
        41,
        248132,
        "Marble statue of an old woman",
        "statue of an old market woman|marble, pentelic|stone sculpture",
        "gr/mobile-large/DP277237.jpg",
        0.73
    ),
    SearchData(
        200,
        468180,
        "Brooch in the Form of a Panther",
        "figurine|copper alloy inlaid with silver and niello|metalwork-copper alloy",
        "md/mobile-large/DP102245.JPG",
        1.06
    ),
    SearchData(
        150,
        250145,
        "Glass fragments of bowl decorated with mosaic fish",
        "dish or plaque fragments|glass|glass",
        "gr/mobile-large/DP140700.jpg",
        0.75
    ),
    SearchData(
        199,
        462907,
        "Key Handle in the Form of a Horse’s Head",
        "key or knife handle|copper alloy|metalwork-copper alloy",
        "md/mobile-large/sf06-176-24s1.jpg",
        2.15
    ),
    SearchData(
        100,
        250625,
        "Bronze specillum (probe)",
        "spoon or ligula|bronze|bronzes",
        "gr/mobile-large/DP20542.jpg",
        1.13
    ),
    SearchData(
        100,
        246537,
        "Bronze jug",
        "jug|bronze|bronzes",
        "gr/mobile-large/DP20308.jpg",
        0.96
    ),
    SearchData(
        17,
        250410,
        "Terracotta vase fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP107058.jpg",
        1.00
    ),
    SearchData(
        100,
        256648,
        "Bronze statuette of Mercury",
        "statuette of hermes|bronze|bronzes",
        "gr/mobile-large/DP133624.jpg",
        0.75
    ),
    SearchData(
        -5,
        248899,
        "Ten marble fragments of the Great Eleusinian Relief",
        "relief fragments from the great eleusinian relief|marble|stone sculpture",
        "gr/mobile-large/DT203390.jpg",
        0.69
    ),
    SearchData(
        150,
        248992,
        "Glass spoon",
        "spoon|glass|glass",
        "gr/mobile-large/DP107040.jpg",
        1.00
    ),
    SearchData(
        20,
        257640,
        "Marble statue of a member of the imperial family",
        "statue of a young man, half-draped|marble|stone sculpture",
        "gr/mobile-large/DP108190.jpg",
        1.00
    ),
    SearchData(
        50,
        257625,
        "Gold pin with obsidian finial",
        "pin with obsidian finial|gold and obsidian|gold and silver",
        "gr/mobile-large/DP-14287-026.jpg",
        2.33
    ),
    SearchData(
        65,
        245397,
        "Glass gladiator cup",
        "gladiator cup|glass|glass",
        "gr/mobile-large/DP104755.jpg",
        1.00
    ),
    SearchData(
        100,
        250470,
        "Terracotta bowl fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP229107.jpg",
        1.33
    ),
    SearchData(
        100,
        256832,
        "Bronze jug handle",
        "handle|bronze, silver|bronzes",
        "gr/mobile-large/DP2075.jpg",
        1.00
    ),
    SearchData(
        249,
        245333,
        "Glass bottle",
        "bottle|glass|glass",
        "gr/mobile-large/DP107634.jpg",
        1.00
    ),
    SearchData(
        50,
        242041,
        "Limestone funerary monument of a woman",
        "statuette of a woman and maid holding casket|limestone|stone sculpture",
        "gr/mobile-large/DP274535.jpg",
        0.75
    ),
    SearchData(
        217,
        249160,
        "Marble sarcophagus fragment: female figure, perhaps a nereid",
        "sarcophagus fragment, nereid|marble|stone sculpture",
        "gr/mobile-large/77985.jpg",
        0.64
    ),
    SearchData(
        50,
        245672,
        "Glass ribbed bowl",
        "bowl, rippenschale|glass|glass",
        "gr/mobile-large/DP120997.jpg",
        1.00
    ),
    SearchData(
        149,
        245829,
        "Marble bust of Herodotos",
        "portrait bust of herodotos|marble, island ?|stone sculpture",
        "gr/mobile-large/DP328506.jpg",
        0.75
    ),
    SearchData(
        400,
        256714,
        "Glass bottle with handles",
        "bottle, handled|glass|glass",
        "gr/mobile-large/DP107029.jpg",
        1.00
    ),
    SearchData(
        50,
        241674,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-265.jpg",
        1.05
    ),
    SearchData(
        150,
        257882,
        "Marble head of Demosthenes",
        "head of demosthenes|marble|stone sculpture",
        "gr/mobile-large/DP326692.jpg",
        0.75
    ),
    SearchData(
        149,
        250953,
        "Marble portrait of Marciana, sister of the emperor Trajan",
        "portrait head of marciana, sister of the emperor trajan|marble|stone sculpture",
        "gr/mobile-large/DP328522.jpg",
        0.75
    ),
    SearchData(
        349,
        256722,
        "Glass bottle with three feet",
        "bottle with three feet|glass|glass",
        "gr/mobile-large/DP108379.jpg",
        1.00
    ),
    SearchData(350, 245402, "Glass jug", "jug|glass|glass", "gr/mobile-large/DP117589.jpg", 1.00),
    SearchData(
        50,
        250493,
        "Obsidian revetment slab fragment",
        "revetment slab fragment|obsidian|glass",
        "gr/mobile-large/DP105520.jpg",
        1.00
    ),
    SearchData(
        0,
        256777,
        "Limestone ossuary with lid",
        "ossuary with lid|limestone, paint|stone sculpture",
        "gr/mobile-large/DP-15733-005.jpg",
        1.38
    ),
    SearchData(
        349,
        245392,
        "Glass bowl with cut decoration",
        "bowl|glass|glass",
        "gr/mobile-large/DP107006.jpg",
        1.00
    ),
    SearchData(
        50,
        246806,
        "Gold ear pick",
        "ear pick or ligula|gold|gold and silver",
        "gr/mobile-large/DP-14287-024.jpg",
        2.53
    ),
    SearchData(
        249,
        257863,
        "Silver spoon and fork",
        "spoon and fork|silver|gold and silver",
        "gr/mobile-large/DP223161.jpg",
        0.47
    ),
    SearchData(
        25,
        250901,
        "Marble fragment of a pilaster",
        "pilaster fragment|marble|stone sculpture",
        "gr/mobile-large/DP271386.jpg",
        0.82
    ),
    SearchData(
        100,
        245305,
        "Glass finger ring",
        "ring|glass|glass",
        "gr/mobile-large/DP121091.jpg",
        0.75
    ),
    SearchData(
        199,
        468220,
        "Funnel-Shaped Mount",
        "finial mount|champlevé enamel, bronze|enamels-champlevé",
        "md/mobile-large/DP102096.JPG",
        1.03
    ),
    SearchData(
        0,
        248267,
        "Glass cameo plaque fragment",
        "cameo plaque fragment, head|glass paste|glass",
        "gr/mobile-large/DP140695.jpg",
        0.75
    ),
    SearchData(
        -50,
        250916,
        "Silver spouted pitcher",
        "pitcher with spout|silver|gold and silver",
        "gr/mobile-large/GR873.jpg",
        1.08
    ),
    SearchData(
        174,
        253565,
        "Mosaic floor panel",
        "mosaic floor with the head of spring|stone, tile, and glass|miscellaneous-mosaic",
        "gr/mobile-large/DP140137.jpg",
        0.91
    ),
    SearchData(
        25,
        250088,
        "Terracotta bowl",
        "cup with base|terracotta|vases",
        "gr/mobile-large/DP107071.jpg",
        1.00
    ),
    SearchData(
        199,
        250097,
        "Terracotta jar with barbotine decoration",
        "urn|terracotta|vases",
        "gr/mobile-large/DP121125.jpg",
        1.00
    ),
    SearchData(
        60,
        245686,
        "Glass cinerary urn with lid",
        "urn with two handles and lid|glass|glass",
        "gr/mobile-large/DP-15454-005.jpg",
        0.75
    ),
    SearchData(
        249,
        245322,
        "Glass jug with chain handle",
        "jug with chain handle|glass|glass",
        "gr/mobile-large/DP107032.jpg",
        1.00
    ),
    SearchData(
        299,
        249633,
        "Glass mosaic fragment",
        "mosaic glass fragment|glass|glass",
        "gr/mobile-large/DP140698.jpg",
        0.75
    ),
    SearchData(
        249,
        250110,
        "Lead-glazed stemmed cup",
        "cup|terracotta|vases",
        "gr/mobile-large/DP107683.jpg",
        1.00
    ),
    SearchData(
        162,
        239665,
        "Glass pourer flask",
        "pourer flask|glass|glass",
        "gr/mobile-large/DP233498.jpg",
        1.33
    ),
    SearchData(
        149,
        248579,
        "Marble head of an athlete",
        "head of an athlete|marble|stone sculpture",
        "gr/mobile-large/DP-14287-137retry.jpg",
        0.81
    ),
    SearchData(
        50,
        250593,
        "Bronze spoon",
        "spoon|bronze|bronzes",
        "gr/mobile-large/DP20485.jpg",
        1.43
    ),
    SearchData(
        -45,
        247009,
        "Wall painting from Room H of the Villa of P. Fannius Synistor at Boscoreale",
        "wall painting|fresco|miscellaneous-stone",
        "gr/mobile-large/DP105943.jpg",
        0.99
    ),
    SearchData(
        100,
        250568,
        "Bronze tweezers",
        "tweezers|bronze|bronzes",
        "gr/mobile-large/DP20480.jpg",
        1.20
    ),
    SearchData(
        199,
        245394,
        "Glass bowl with cut decoration",
        "bowl|glass|glass",
        "gr/mobile-large/DP117538.jpg",
        1.00
    ),
    SearchData(
        13,
        241622,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-251.jpg",
        0.83
    ),
    SearchData(
        325,
        245375,
        "Glass double head-shaped flask",
        "flask, double head-shaped with handle|glass|glass",
        "gr/mobile-large/DP107005.jpg",
        1.00
    ),
    SearchData(
        -5,
        250942,
        "Wall painting on red ground: candelabrum with frieze, from the imperial villa at Boscotrecase",
        "wall painting on red ground: candelabrum with frieze|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP138759.jpg",
        0.70
    ),
    SearchData(
        50,
        250355,
        "Terracotta lamp handle",
        "lamp handle|terracotta|terracottas",
        "gr/mobile-large/DP229104.jpg",
        1.33
    ),
    SearchData(249, 245718, "Glass bowl", "bowl|glass|glass", "gr/mobile-large/DP107008.jpg", 1.00),
    SearchData(
        25,
        257879,
        "Glass two-handled bottle (amphora)",
        "amphora, pointed|glass, purple|glass",
        "gr/mobile-large/DP281253.jpg",
        0.75
    ),
    SearchData(
        50,
        255092,
        "Bronze phallic amulet",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP-12765-001.jpg",
        1.33
    ),
    SearchData(
        174,
        257818,
        "Marble strigilated vase with snake handles",
        "strigilated vase with snake handles and lid|marble|stone sculpture",
        "gr/mobile-large/DP146528.jpg",
        1.15
    ),
    SearchData(
        22,
        250775,
        "Terracotta modiolus (drinking cup)",
        "cup, \"modiolus\"|terracotta|vases",
        "gr/mobile-large/DP1411.jpg",
        1.00
    ),
    SearchData(
        50,
        245382,
        "Glass lentoid amphoriskos",
        "amphoriskos, lentoid with rosette|glass|glass",
        "gr/mobile-large/DP231281.jpg",
        0.75
    ),
    SearchData(
        50,
        255091,
        "Bronze phallic ornament",
        "amulet, grotesque ornament|bronze|bronzes",
        "gr/mobile-large/DP20804.jpg",
        1.00
    ),
    SearchData(
        100,
        246903,
        "Bronze aryballos",
        "bottle|bronze|bronzes",
        "gr/mobile-large/DP20370.jpg",
        0.99
    ),
    SearchData(
        -1,
        250325,
        "Terracotta bowl fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP121115.jpg",
        1.00
    ),
    SearchData(
        124,
        245624,
        "Glass cinerary urn",
        "urn with two handles|glass|glass",
        "gr/mobile-large/DP121449.jpg",
        1.00
    ),
    SearchData(
        41,
        245848,
        "Wall painting fragment with winged figure",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112921.jpg",
        1.00
    ),
    SearchData(
        25,
        245376,
        "Glass hexagonal amphoriskos",
        "amphoriskos, ennion|glass|glass",
        "gr/mobile-large/DP124005.jpg",
        0.75
    ),
    SearchData(
        199,
        245377,
        "Glass flask decorated with intersecting circles",
        "flask|glass|glass",
        "gr/mobile-large/DP107638.jpg",
        1.00
    ),
    SearchData(
        25,
        245470,
        "Glass mosaic perfume bottle",
        "perfume bottle, mosaic|glass|glass",
        "gr/mobile-large/DP141522.jpg",
        1.00
    ),
    SearchData(349, 249642, "Glass bead", "bead|glass|glass", "gr/mobile-large/DP121021.jpg", 0.75),
    SearchData(
        200,
        475394,
        "Zoomorphic Brooch",
        "brooch|copper alloy, champlevé enamel|enamels-champlevé",
        "md/mobile-large/tr777-2002s1.jpg",
        1.33
    ),
    SearchData(
        299,
        465324,
        "Spoon with a Panther",
        "spoon|copper alloy, silvered, niello|metalwork-copper alloy",
        "md/mobile-large/sf17-192-254s1.jpg",
        1.33
    ),
    SearchData(
        312,
        468268,
        "Sarcophagus with a Greek Physician",
        "sarcophagus|marble|sculpture-stone",
        "md/mobile-large/DT11898.jpg",
        3.38
    ),
    SearchData(
        40,
        253324,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112914.jpg",
        1.00
    ),
    SearchData(
        34,
        249627,
        "Glass and gold inlay",
        "mosaic block inlay|glass and gold|glass",
        "gr/mobile-large/sf17194391color.jpg",
        1.09
    ),
    SearchData(
        50,
        245656,
        "Glass ribbed bowl",
        "bowl, rippenschale|glass|glass",
        "gr/mobile-large/DP141524.jpg",
        1.00
    ),
    SearchData(
        25,
        257610,
        "Marble cinerary urn",
        "cinerary urn|marble|stone sculpture",
        "gr/mobile-large/DT5415.jpg",
        1.25
    ),
    SearchData(
        125,
        250463,
        "Terracotta lead-glazed lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP106598.jpg",
        1.00
    ),
    SearchData(
        40,
        253333,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP114267.jpg",
        1.00
    ),
    SearchData(
        0,
        251457,
        "Terracotta dish",
        "plate|terracotta|vases",
        "gr/mobile-large/DP107324.jpg",
        1.00
    ),
    SearchData(
        40,
        253331,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112913.jpg",
        1.00
    ),
    SearchData(
        12,
        257828,
        "Glass mosaic bowl fragment",
        "mosaic glass fragment|glass|glass",
        "gr/mobile-large/DP145726.jpg",
        1.33
    ),
    SearchData(
        134,
        257825,
        "Marble portrait head of Antinoos",
        "portrait head of antinoos|marble|stone sculpture",
        "gr/mobile-large/DP333683.jpg",
        0.75
    ),
    SearchData(
        12,
        257826,
        "Mosaic glass bowl fragment",
        "mosaic glass fragment|glass|glass",
        "gr/mobile-large/DP145724.jpg",
        1.33
    ),
    SearchData(
        149,
        246912,
        "Bronze handle attachment",
        "handle attachments for a situla|bronze|bronzes",
        "gr/mobile-large/DP20379.jpg",
        0.95
    ),
    SearchData(
        25,
        251473,
        "Marble relief fragment with scenes from the Trojan War",
        "relief fragment with scenes from the siege of troy, tabula iliaca|marble, palombino|stone sculpture",
        "gr/mobile-large/DP202060.jpg",
        1.33
    ),
    SearchData(
        50,
        250913,
        "Marble statue of Aphrodite loosening her sandal",
        "statuette of aphrodite|marble, parian ?|stone sculpture",
        "gr/mobile-large/DP271463.jpg",
        0.73
    ),
    SearchData(
        41,
        245838,
        "Wall painting fragment with Gorgon mask",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112917.jpg",
        1.00
    ),
    SearchData(
        100,
        253373,
        "Marble statue of a wounded Amazon",
        "statue of a wounded amazon|marble|stone sculpture",
        "gr/mobile-large/DP277772.jpg",
        0.65
    ),
    SearchData(
        50,
        250591,
        "Bronze knife with ram\"s-head handle",
        "knife with ram\"s head|bronze|bronzes",
        "gr/mobile-large/DP20479.jpg",
        0.96
    ),
    SearchData(
        0,
        253387,
        "Bronze furniture attachment",
        "furniture attachment, rinceau of acanthus|bronze|bronzes",
        "gr/mobile-large/DP106985.jpg",
        1.00
    ),
    SearchData(
        299,
        246102,
        "Gold ornament with cloisons",
        "bead ornament|gold|gold and silver",
        "gr/mobile-large/DP136023.jpg",
        1.33
    ),
    SearchData(
        159,
        251929,
        "Marble statue of a wounded warrior",
        "statue of a wounded warrior, protesilaos ?|marble|stone sculpture",
        "gr/mobile-large/DT278.jpg",
        0.65
    ),
    SearchData(
        299,
        249668,
        "Glass pendant shaped like a jar",
        "pendant|glass|glass",
        "gr/mobile-large/DP121027.jpg",
        0.75
    ),
    SearchData(
        50,
        257613,
        "Marble mask of Pan",
        "mask of pan|marble|stone sculpture",
        "gr/mobile-large/GR891.jpg",
        0.83
    ),
    SearchData(
        110,
        241625,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-22527-115.jpg",
        0.84
    ),
    SearchData(349, 245342, "Glass jug", "jug|glass|glass", "gr/mobile-large/DP107003.jpg", 1.00),
    SearchData(299, 245396, "Glass bowl", "bowl|glass|glass", "gr/mobile-large/DP107007.jpg", 1.00),
    SearchData(
        50,
        245810,
        "Glass mosaic ornament in the form of a shell",
        "ornament in the form of a shell|glass|glass",
        "gr/mobile-large/DP121095.jpg",
        0.75
    ),
    SearchData(
        100,
        250645,
        "Marble relief fragment",
        "relief fragment with feline among acanthus leaves|marble, palombino|stone sculpture",
        "gr/mobile-large/SF17230118b.jpg",
        1.21
    ),
    SearchData(
        399,
        256709,
        "Glass jug with indented body",
        "jug|glass|glass",
        "gr/mobile-large/DP108373.jpg",
        1.00
    ),
    SearchData(
        25,
        245727,
        "Glass mosaic bottle",
        "perfume bottle, mosaic|glass|glass",
        "gr/mobile-large/DP120999.jpg",
        1.00
    ),
    SearchData(
        125,
        250477,
        "Terracotta jug fragment",
        "vase fragment|terracotta|vases",
        "gr/mobile-large/DP121122.jpg",
        1.00
    ),
    SearchData(
        0,
        250153,
        "Faience statuette fragment of Venus",
        "statuette fragment of venus|faience|miscellaneous-faience",
        "gr/mobile-large/DP231268.jpg",
        0.75
    ),
    SearchData(
        649,
        241680,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP105624.jpg",
        1.00
    ),
    SearchData(
        375,
        465927,
        "Bowl Base",
        "bowl fragment|glass, gold leaf|glass-gold glass",
        "md/mobile-large/sf18-145-6s1b.jpg",
        1.00
    ),
    SearchData(
        -8,
        250252,
        "Terracotta cup",
        "cup|terracotta|vases",
        "gr/mobile-large/DP107077.jpg",
        1.00
    ),
    SearchData(
        0,
        245596,
        "Glass mosaic inlay fragment",
        "fragment, mosaic inlay|glass|glass",
        "gr/mobile-large/DP21836edited.jpg",
        1.00
    ),
    SearchData(
        34,
        248892,
        "Bronze portrait of a man",
        "portrait bust of a man (agrippa / marcus antonius?)|bronze|bronzes",
        "gr/mobile-large/DP337268.jpg",
        0.75
    ),
    SearchData(
        250,
        465919,
        "Fragment of a Sarcophagus with a Seated Figure",
        "relief fragment|marble|sculpture-stone",
        "md/mobile-large/DP-14287-046.jpg",
        0.85
    ),
    SearchData(
        50,
        241652,
        "Terracotta oil lamp",
        "lamp|terracotta|terracottas",
        "gr/mobile-large/DP-19673-099.jpg",
        0.90
    ),
    SearchData(
        349,
        246975,
        "Bronze lamp",
        "lamp|bronze|bronzes",
        "gr/mobile-large/DP20380.jpg",
        0.96
    ),
    SearchData(
        153,
        258543,
        "Stone head of a Julio-Claudian youth, possibly of Gaius Caesar",
        "head, gaius caesar|gypsum alabaster|stone sculpture",
        "gr/mobile-large/DP333705.jpg",
        0.75
    ),
    SearchData(
        299,
        246764,
        "Bronze ring key",
        "key|bronze|bronzes",
        "gr/mobile-large/DP20344.jpg",
        0.93
    ),
    SearchData(
        -6,
        257862,
        "Bronze ornament in the form of a seated male sphinx",
        "ornament in the form of a seated male sphinx|bronze|bronzes",
        "gr/mobile-large/DP223155.jpg",
        0.75
    ),
    SearchData(
        25,
        250176,
        "Fragmentary terracotta scyphus (drinking cup)",
        "skyphos fragment|terracotta|vases",
        "gr/mobile-large/DP107685.jpg",
        1.00
    ),
    SearchData(
        187,
        250087,
        "Terracotta dish with barbotine decoration",
        "bowl|terracotta|vases",
        "gr/mobile-large/DP231272.jpg",
        1.33
    ),
    SearchData(
        61,
        245831,
        "Stucco relief panel",
        "stucco relief|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-076.jpg",
        1.00
    ),
    SearchData(
        74,
        245384,
        "Glass amphoriskos with horizontal ribs",
        "miniature transport amphora|glass|glass",
        "gr/mobile-large/DP146601.jpg",
        0.75
    ),
    SearchData(
        0,
        250111,
        "Terracotta askos (flask with a spout and handle over the top)",
        "askos|terracotta|vases",
        "gr/mobile-large/DP1445_17.194.885.jpg",
        1.00
    ),
    SearchData(
        17,
        249158,
        "Glass cameo cup fragment",
        "cameo, cup fragment|glass|glass",
        "gr/mobile-large/DP155139.jpg",
        1.00
    ),
    SearchData(
        162,
        250926,
        "Marble sarcophagus fragment",
        "sarcophagus fragment|marble, luni and pentelic|stone sculpture",
        "gr/mobile-large/DP310512.jpg",
        1.23
    ),
    SearchData(
        50,
        245391,
        "Glass ribbed bowl",
        "bowl, rippenschale|glass|glass",
        "gr/mobile-large/DP141521.jpg",
        1.00
    ),
    SearchData(
        150,
        251418,
        "Fragment from a marble head of a man, preserving the nose and mouth",
        "head, fragment, man\"s nose and mouth|marble|stone sculpture",
        "gr/mobile-large/DP202799.jpg",
        1.00
    ),
    SearchData(
        249,
        250085,
        "Terracotta jug in the shape of a head of a Black African",
        "jug in the shape of a head of an african|terracotta|vases",
        "gr/mobile-large/DP121790.jpg",
        1.00
    ),
    SearchData(
        75,
        245380,
        "Glass jug in the form of a pine cone",
        "flask in the form of a pine cone|glass|glass",
        "gr/mobile-large/DP117536.jpg",
        1.00
    ),
    SearchData(
        -50,
        250914,
        "Silver skyphos (drinking cup)",
        "skyphos|silver|gold and silver",
        "gr/mobile-large/GR875.jpg",
        1.08
    ),
    SearchData(
        74,
        245832,
        "Stucco relief panel",
        "stucco relief of maenad|stucco|miscellaneous-stucco",
        "gr/mobile-large/DP-14287-075.jpg",
        0.85
    ),
    SearchData(
        249,
        246842,
        "Bead ornaments, triangular, 8",
        "bead ornaments, triangular, 8|gold|gold and silver",
        "gr/mobile-large/DP30699.jpg",
        0.93
    ),
    SearchData(
        149,
        465206,
        "Brooch in the Form of a Dog Attacking a Boar",
        "brooch|champlevé enamel, bronze, gold|enamels-champlevé",
        "md/mobile-large/sf17-192-148s1.jpg",
        1.49
    ),
    SearchData(
        149,
        245585,
        "Marble sarcophagus with garlands and the myth of Theseus and Ariadne",
        "sarcophagus, garland|marble, luni and pentelic|stone sculpture",
        "gr/mobile-large/DP138720.jpg",
        1.95
    ),
    SearchData(
        25,
        257619,
        "Marble fragment of a cinerary urn",
        "cinerary urn, fragment|indurated limestone or fine-grained marble|stone sculpture",
        "gr/mobile-large/DT1064.jpg",
        1.25
    ),
    SearchData(
        149,
        250236,
        "Terracotta hanging lamp in the form of a comic actor",
        "lamp in the form of an actor|terracotta|terracottas",
        "gr/mobile-large/DP105841.jpg",
        1.00
    ),
    SearchData(
        249,
        250797,
        "Silver spoon",
        "spoon|silver|gold and silver",
        "gr/mobile-large/DP107024.jpg",
        1.00
    ),
    SearchData(
        25,
        245665,
        "Glass mosaic perfume bottle",
        "perfume bottle, mosaic|glass|glass",
        "gr/mobile-large/DP107099.jpg",
        1.00
    ),
    SearchData(
        25,
        245475,
        "Glass mosaic bottle",
        "bottle, mosaic|glass|glass",
        "gr/mobile-large/DP120994.jpg",
        1.00
    ),
    SearchData(
        25,
        245723,
        "Glass mosaic pyxis with lid",
        "pyxis with lid|glass|glass",
        "gr/mobile-large/DP104759-9111335.jpg",
        0.87
    ),
    SearchData(
        149,
        246913,
        "Bronze handle attachment",
        "handle attachment for a situla|bronze|bronzes",
        "gr/mobile-large/DP20378.jpg",
        1.01
    ),
    SearchData(
        40,
        253329,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112916.jpg",
        1.00
    ),
    SearchData(
        34,
        249625,
        "Glass mosaic inlay",
        "mosaic block inlay|glass|glass",
        "gr/mobile-large/sf17194389color_ed.jpg",
        1.12
    ),
    SearchData(
        40,
        253330,
        "Wall painting fragment",
        "wall painting fragment|fresco|miscellaneous-paintings",
        "gr/mobile-large/DP112912.jpg",
        1.00
    ),
    SearchData(
        175,
        468226,
        "Cup or Bowl",
        "cup or bowl|champlevé enamel, bronze, silver liner and bottom|enamels-champlevé",
        "md/mobile-large/sf47-100-8s1.jpg",
        1.41
    ),
    SearchData(
        50,
        250494,
        "Obsidian revetment slab fragment",
        "revetment slab fragment|obsidian|glass",
        "gr/mobile-large/DP105519.jpg",
        1.00
    ),
    SearchData(
        100,
        251416,
        "Marble leg of a table with a tiger\"s head",
        "table leg|marble|stone sculpture",
        "gr/mobile-large/DP232662.jpg",
        0.51
    ),
    SearchData(
        0,
        249414,
        "Glass oinochoe (jug)",
        "oinochoe|glass|glass",
        "gr/mobile-large/DT203394.jpg",
        0.80
    ),
    SearchData(
        249,
        256724,
        "Glass bottle in the shape of an animal",
        "bottle in the form of an animal|glass|glass",
        "gr/mobile-large/DP108401.jpg",
        1.00
    ),
    SearchData(
        50,
        253379,
        "Marble portrait bust of a boy",
        "portrait bust of a boy|marble|stone sculpture",
        "gr/mobile-large/DP328528.jpg",
        0.75
    ),
)